export type UUID = string;

export const ROOM_IMAGE_SLOTS = ["room", "shelf", "fireplace", "table"] as const;
export type RoomImageSlot = (typeof ROOM_IMAGE_SLOTS)[number];
export type RoomImageAssets = Record<RoomImageSlot, UUID | null>;
export type RoomFurnitureSlot = Exclude<RoomImageSlot, "room">;

export interface FurnitureGeometry {
  /** Left edge as a normalized fraction of the room stage width. */
  x: number;
  /** Top edge as a normalized fraction of the room stage height. */
  y: number;
  /** Width as a normalized fraction of the room stage width. */
  width: number;
}

export type RoomFurnitureLayout = Record<RoomFurnitureSlot, FurnitureGeometry>;

export interface Placement {
  id: UUID;
  assetId: UUID;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  layer: number;
}

export interface AlbumPage {
  id: UUID;
  placements: Placement[];
}

export interface AlbumDocument {
  id: UUID;
  title: string;
  coverAssetId: UUID | null;
  aspectRatio: number;
  revision: number;
  baseRevision: number | null;
  pages: AlbumPage[];
  createdAt: string;
  updatedAt: string;
  conflictCopyOf: UUID | null;
  syncedRevision: number | null;
}

export type AssetVariant = "original" | "display" | "thumbnail";

export interface AssetRecord {
  id: UUID;
  mimeType: string;
  width: number;
  height: number;
  sha256: string;
  description: string | null;
  variants: Record<AssetVariant, { opfsPath: string; size: number }>;
  createdAt: string;
  status: "pending" | "ready" | "failed";
}

export interface AppSettings {
  id: "settings";
  theme: "light" | "dark" | "system";
  reducedMotion: boolean;
  syncEnabled: boolean;
  lastSyncAt: string | null;
  deviceId: UUID;
  roomImages: RoomImageAssets;
  roomFurnitureLayout: RoomFurnitureLayout;
}

export interface RecoveryJournalEntry {
  key: string;
  assetId: string;
  variant: AssetVariant;
  opfsPath: string;
  createdAt: string;
}

export const DB_SCHEMA_VERSION = 3;
export const MAX_IMAGE_BYTES = 25 * 1024 * 1024;
export const MAX_IMAGE_PIXELS = 40_000_000;
export const DEFAULT_ASPECT_RATIO = 1;
